import { render, staticRenderFns } from "./CopyFoodcardForm.vue?vue&type=template&id=fe447930"
import script from "./CopyFoodcardForm.vue?vue&type=script&lang=ts"
export * from "./CopyFoodcardForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports